/**
 * Modül-bazlı (à-la-carte) lisanslama tanımları.
 * Her modül AYRI fiyatlandırılır/açılır. Parça Takip = premium (sunucu tarafı, yapışkan).
 * Entitlement abonelikler koleksiyonunda (veri.moduller[]) tutulur — [[project_modul_lisans_parca_takip]].
 */
export type ModulId =
  | 'GORUNTULEME' | 'ANALIZ' | 'ACILI_KAFA' | 'OLCUM' | 'CIZIM' | 'CAM' | 'PARCA_TAKIP';

/** Workbench içindeki katma değerli (premium) komut — ek ücretlendirilir. */
export interface IKomut {
  id: string;          // workbench içinde benzersiz komut anahtarı
  baslik: string;
  ekFiyat: number;     // ₺/ay (workbench ücretine EK)
}

/** Bir WORKBENCH (= modül). Workbench baz ücreti + içindeki premium komutlar ayrı ek ücret. */
export interface IModul {
  id: ModulId;
  baslik: string;
  simge: string;
  aciklama: string;
  aylikFiyat: number;   // ₺/ay (workbench baz)
  premium?: boolean;
  komutlar?: IKomut[];  // katma değerli komutlar (ek ücretli)
}

export const MODULLER: IModul[] = [
  {
    id: 'GORUNTULEME', baslik: 'Görüntüleme', simge: '👁️', aciklama: 'STP/STEP içe aktarma + 3D model görüntüleme & navigasyon (import dahil)', aylikFiyat: 700,
    komutlar: [
      { id: 'patlatma', baslik: 'Patlatma (Exploded)', ekFiyat: 300 },
      { id: 'xray', baslik: 'X-Ray / Şeffaf Mod', ekFiyat: 200 },
      { id: 'kesit_gorunum', baslik: 'Kesit Görünümü', ekFiyat: 200 },
      { id: 'render', baslik: 'Render Modları (NPR/Toon)', ekFiyat: 200 },
      { id: 'ar_modu', baslik: 'AR Modu (Kamera Arka Plan)', ekFiyat: 300 },
    ],
  },
  {
    id: 'OLCUM', baslik: 'Ölçüm', simge: '📏', aciklama: 'CATIA seviyesi 3D ölçüm araçları (her araç ayrı)', aylikFiyat: 400,
    komutlar: [
      { id: 'kumpas', baslik: 'Kumpas (Nokta-Nokta Mesafe)', ekFiyat: 200 },
      { id: 'cetvel', baslik: 'Cetvel (Kenar/Çizgi Uzunluk)', ekFiyat: 200 },
      { id: 'aci', baslik: 'Açı Ölçer', ekFiyat: 200 },
      { id: 'cap', baslik: 'Çap / Yarıçap', ekFiyat: 200 },
      { id: 'min_mesafe', baslik: 'Min. Mesafe (Yüzey-Yüzey)', ekFiyat: 300 },
      { id: 'alan_hacim', baslik: 'Alan & Hacim', ekFiyat: 300 },
      { id: 'agirlik', baslik: 'Ağırlık (Uzun-bas kg/ölçü)', ekFiyat: 300 },
      { id: 'gdt', baslik: 'GD&T / Geometrik Tolerans', ekFiyat: 500 },
      { id: 'kalici_olcu', baslik: 'Kalıcı Ölçüm Etiketleri', ekFiyat: 300 },
      { id: 'cmm_tarama', baslik: 'Canlı Tarama (Mobil CMM Kamera)', ekFiyat: 400 },
      { id: 'muayene', baslik: 'Muayene Raporu (FAI/PPAP)', ekFiyat: 600 },
      { id: 'tolerans_yigini', baslik: 'Tolerans Yığını (Stack-up)', ekFiyat: 400 },
    ],
  },
  {
    id: 'ANALIZ', baslik: 'Analiz', simge: '📊', aciklama: 'DFM/döküm, ters açı, kalınlık, radius analizleri', aylikFiyat: 500,
    komutlar: [
      { id: 'dokum', baslik: 'Döküm / DFM Analizi', ekFiyat: 400 },
      { id: 'ters_aci', baslik: 'Ters Açı (Undercut)', ekFiyat: 300 },
      { id: 'kalinlik', baslik: 'Et Kalınlığı', ekFiyat: 300 },
      { id: 'radius', baslik: 'Radius / Erişilebilirlik', ekFiyat: 300 },
      { id: 'dokum_kontrol', baslik: 'Döküm Kontrol Modülü', ekFiyat: 400 },
      // ── Üretim & Maliyet paketi ──
      { id: 'uretim_karti', baslik: 'Üretim Kartı (Maliyet Dashboard)', ekFiyat: 800 },
      { id: 'teklif', baslik: 'Anlık Teklif / Maliyet Motoru', ekFiyat: 600 },
      { id: 'feature_tani', baslik: 'Oto Özellik Tanıma → CAM', ekFiyat: 600 },
      { id: 'nesting', baslik: 'Nesting / Levha Yerleşim', ekFiyat: 800 },
      { id: 'malzeme_karsilastir', baslik: 'Malzeme / Maliyet / CO₂ Karşılaştırma', ekFiyat: 300 },
      { id: 'bukum_acinim', baslik: 'Büküm Açınımı (Sac Metal Flat Pattern)', ekFiyat: 400 },
      { id: 'kaplama_maliyeti', baslik: 'Yüzey İşlem / Kaplama Maliyeti', ekFiyat: 300 },
      { id: 'uretim_takvimi', baslik: 'Üretim Takvimi / Termin Planı', ekFiyat: 400 },
    ],
  },
  {
    id: 'ACILI_KAFA', baslik: 'Açılı Kafa Tespiti', simge: '🧭', aciklama: 'Tool axis / açılı kafa kurulum tespiti', aylikFiyat: 400,
    komutlar: [
      { id: 'ozmo', baslik: 'Ozmo Kafa', ekFiyat: 500 },
      { id: 'diagonal', baslik: 'Diagonal Kafa (WTEC)', ekFiyat: 500 },
    ],
  },
  {
    id: 'CIZIM', baslik: 'Çizim / Teknik Resim', simge: '✏️', aciklama: '2D teknik resim & parametrik çizim', aylikFiyat: 1000,
    komutlar: [
      { id: 'sketch', baslik: 'Sketch (2D Eskiz)', ekFiyat: 400 },
      { id: 'parametrik', baslik: 'Parametrik Katı (PartDesign Pad/Pocket...)', ekFiyat: 800 },
      { id: 'cizgi_3d', baslik: '3D Çizgi / Polyline / Spline', ekFiyat: 400 },
      { id: 'teknik_resim', baslik: '2D Teknik Resim Çıktısı', ekFiyat: 500 },
      { id: 'dxf_disa', baslik: 'DXF Dışa Aktarma (2D)', ekFiyat: 500 },
      { id: 'is_emri', baslik: 'QR İş Emri & Etiket', ekFiyat: 400 },
    ],
  },
  {
    id: 'CAM', baslik: 'CAM', simge: '⚙️', aciklama: 'Takım yolu, NC kod, simülasyon', aylikFiyat: 1500,
    komutlar: [
      { id: 'cam_2d', baslik: '2D CAM (Cep/Kontur/Delik)', ekFiyat: 800 },
      { id: 'bes_eksen', baslik: '3+2 / 5 Eksen', ekFiyat: 1500 },
      { id: 'simulasyon', baslik: 'Takım Yolu Simülasyonu', ekFiyat: 1000 },
      { id: 'nc_post', baslik: 'NC Post (G68.2)', ekFiyat: 800 },
      { id: 'kesim_maliyeti', baslik: 'Kesim Maliyeti (Lazer/Plazma/Su Jeti)', ekFiyat: 500 },
      { id: 'kesme_parametre', baslik: 'Kesme Parametreleri (Speeds & Feeds)', ekFiyat: 400 },
    ],
  },
  // NOT: Parça Takip 3D-içi workbench DEĞİL, ayrı bir uygulama (route 📦) — "Uygulamalar" sekmesinden (alt özellikleriyle) yönetilir.
];

export const MODUL_BUL = (id: ModulId): IModul | undefined => MODULLER.find(m => m.id === id);
/** "workbenchId:komutId" anahtarı (entitlement saklama). */
export const KOMUT_ANAHTAR = (wbId: ModulId, komutId: string) => `${wbId}:${komutId}`;
